/**
 * Pathname with a trailing `.html` stripped.
 *
 * Emergent's production origin only serves prerendered static HTML at
 * `<path>.html`; every extensionless path falls back to the SPA shell
 * (verified 2026-09: an arbitrary non-existent path returns the same
 * 32,511-byte landing shell). So `.html` is the form we advertise to
 * crawlers — sitemap, canonical tags and the internal links inside the
 * prerendered HTML — and therefore the form users arrive on from search.
 *
 * The router compares the pathname as an exact string in ~20 places, so it
 * is normalised ONCE here instead of adding a `.html` variant to every
 * comparison. Without this, `/exercises/ab-crunch-machine.html` produces
 * the slug `ab-crunch-machine.html` and renders "Exercise not found".
 */
export const appPathname = (): string =>
  window.location.pathname.replace(/\.html$/i, '');
